import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { fetchProducts } from '../utils/api';
import { FaPlus, FaMinus, FaCartPlus } from "react-icons/fa";
import { useCart } from '../context/CartContext';

const FeaturedProducts = () => {
    const [products, setProducts] = useState([]);
    const { addToCart, cartItems, incrementItem, decrementItem, } = useCart();


    useEffect(() => {
        const getProducts = async () => {
            try {
                const data = await fetchProducts();

                const featuredProducts = data.filter(product => product.featured);

                for (let i = featuredProducts.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [featuredProducts[i], featuredProducts[j]] = [featuredProducts[j], featuredProducts[i]];
                }

                setProducts(featuredProducts.slice(0, 6));
            } catch (error) {
                console.error("Feil ved henting av produkter:", error);
            }
        };
        getProducts();
    }, []);

    const handleAddToCart = (product) => {
        addToCart(product);
    };

    const isInCart = (cartItems, productId) => {
        return cartItems.find(item => item._id === productId);
    }


    return (
        <div className='container featured'>
            <h1 className='section-title'>Utvalgte Produkter</h1>
            <div className='section-border'></div>

            <GridContainer>
                {products.map((product) => {
                    const cartItem = isInCart(cartItems, product._id);

                    return (
                        <ProductCard key={product._id}>
                            {product.bulkDiscounts && product.bulkDiscounts.length > 0 && (
                                <DiscountBadge>
                                    Tilbud
                                </DiscountBadge>
                            )}
                            <ImageContainer>
                                <img src={product.image} alt={product.name} />
                            </ImageContainer>

                            <ProductInfo>
                                <h3>{product.name}</h3>
                                <div className="product-info-bottom">
                                    <p>{product.description}</p>
                                    <span>{product.price} Kr</span>
                                </div>
                            </ProductInfo>
                            
                            {cartItem ? (
                                <QuantityControls>
                                    <Button onClick={() => decrementItem(product._id)}><FaMinus /></Button>
                                    <Quantity>{cartItem.quantity}</Quantity>
                                    <Button onClick={() => incrementItem(product._id)}><FaPlus /></Button>
                                </QuantityControls>
                            ) : (
                                <AddToCartButton
                                    onClick={() => handleAddToCart(product)}
                                >
                                    <FaCartPlus size={22}/>
                                </AddToCartButton>
                            )}
                        </ProductCard>
                    )
                })}
            </GridContainer>
        </div>
    )
}

export default FeaturedProducts

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 2rem;
    justify-items: center;

    @media (max-width: 768px) {
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    }
`;

const ImageContainer = styled.div`
    position: relative;
    z-index: 1;

    @media (max-width: 768px) {
        max-height: 150px;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        transition: transform .2s ease-in-out;

        &:hover {
            transform: translateY(-5px);
        }
    }
`;

const ProductCard = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    width: 100%;
`;

const ProductInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;

    h3 {
        cursor: pointer;
        margin-top: 8px;
        width: 100%;
        color: black;

        @media (max-width: 768px) {
            font-size: .8rem;
        }
    }

    .product-info-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
            font-size: 12px;
            color: #807d7d;
            width: 70%;

            @media (max-width: 768px) {
                font-size: 10px;
            }
        }

        span {
            font-size: 24px;
            color: #b31a1a;
            font-weight: bold;

            @media (max-width: 768px) {
                font-size: .8rem;
            }
        }
    }
`;

const AddToCartButton = styled.button`
    background: #B22222;
    color: white;
    border: none;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    align-self: flex-end;
    margin-top: auto;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
        background: #991b1b;
    }

    @media (max-width: 480px) {
        padding: 6px 10px;
    }
`;

const QuantityControls = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: auto;
    align-self: flex-end;
`;

const Button = styled.button`
    background: #2d6a4f;
    color: white;
    border: none;
    padding: 8px 10px;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
        background: #1b4332;
    }
`;

const Quantity = styled.span`
    font-size: 1.2rem;
    font-weight: bold;
`;

const DiscountBadge = styled.div`
    position: absolute;
    top: 0px;
    left: -5px;
    background: #d32f2f;
    color: white;
    font-size: 10px;
    font-weight: bold;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    text-transform: uppercase;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    z-index: 2;
`;